var e="MP_CLOTHING_DEPARTMENTS";export{e as a};
